import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";

import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useMeetings } from "../../../context/MeetingsContext";
import CustomEvent from "./CustomeEvent";
import axios from "axios";
import { API_BASE_URL } from "../../Apicongfig";
import { formatDate, formatTime } from "./GetMeeting/Helpers/functionHelper";
import ReactToggle from "react-toggle"; // Assuming you have this package installed
import { useFormContext } from "../../../context/CreateMeetingContext";
import { useHeaderTitle } from "../../../context/HeaderTitleContext";
import { abortMeetingTime } from "../../Utils/MeetingFunctions";
import { ProgressBar } from "react-bootstrap";
import CustomToolbar from "./CustomToolbar";
import { useDraftMeetings } from "../../../context/DraftMeetingContext";

const EventWrapper = ({ children }) => {
  return <div style={{ marginBottom: "2px", width: "100%" }}>{children}</div>;
};

const CustomDateHeader = ({ label, date, localizer }) => {
  return <div>{moment(date).format("ddd D MMM")}</div>;
};

const MonthEvent = ({ event }) => {
  return (
    <div
      style={{
        fontSize: "12px",
        padding: "2px",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      {event.title}
    </div>
  );
};

const MonthDateHeader = ({ label, date, localizer }) => {
  return (
    <div style={{ textAlign: "center", padding: "5px" }}>
      {moment(date).format("D")}
    </div>
  );
};

const ReactBigCalendar = ({}) => {
  const { updateLanguage } = useDraftMeetings();
  const [t] = useTranslation("global");
  const navigate = useNavigate();
  const [myEventsList, setMyEventsList] = useState([]);
  const [overlappingSlots, setOverlappingSlots] = useState(new Set());
  const { googleLoginAndSaveProfileScheduled, setFormState, setMeeting,outlookLoginAndSaveProfile } =
    useFormContext();
  const {
    setOffset,
    setAgendaEventOffset,
    selectedAgenda,
    setSelectedAgenda,
    setAgendaCount,
  } = useMeetings();
  const { setUser, user, callUser } = useHeaderTitle();
  const [currentStartDate, setCurrentStartDate] = useState(
    moment().startOf("week").toDate()
  );
  const [currentView, setCurrentView] = useState(Views.WEEK); // Track current view

  const { language } = useDraftMeetings();

  useEffect(() => {
    moment.locale(language);
  }, [language]);

  const localizer = momentLocalizer(moment);

  const [btnDisable, setBtnDisable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [firstTime, setFirstTime] = useState(true);
  const [closedProgress, setClosedProgress] = useState(0);

  const [filteredEvents, setFilteredEvents] = useState([]);
  const { searchTerm, setSearchTerm } = useOutletContext();

// Add this useEffect to filter events when searchQuery or myEventsList changes
useEffect(() => {
  if (searchTerm.trim() === '') {
    setFilteredEvents(myEventsList);
  } else {
    const filtered = myEventsList.filter(event => 
      event.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredEvents(filtered);
  }
}, [searchTerm, myEventsList]);
  const formatDateForApi = (date) => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")}`;
  };
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [min, setMin] = useState(null);
  const [max, setMax] = useState(null);

  useEffect(() => {
    const currentDate = new Date();
    const startOfWeek = new Date(currentDate);
    startOfWeek.setDate(currentDate.getDate() - currentDate.getDay());
    startOfWeek.setHours(0, 0, 0, 0);

    const endOfWeek = new Date(currentDate);
    endOfWeek.setDate(currentDate.getDate() - currentDate.getDay() + 6);
    endOfWeek.setHours(23, 59, 59, 999);

    setMin(startOfWeek);
    setMax(endOfWeek);
  }, []);

  const [earliestHour, setEarliestHour] = useState(9);
  const [latestHour, setLatestHour] = useState(17);
  // Add this state near your other state declarations
  const [syncAgenda, setSyncAgenda] = useState(false);

  const getEmptyFormState = () => ({
    selectedOption: null,
    title: null,
    date: null,
    start_time: null,
    description: null,
    type: null,
    priority: null,
    alarm: false,
    feedback: false,
    remainder: false,
    autostart: false,
    playback: "Manual",
    prise_de_notes: "Manual",
    note_taker: false,
    objective: null,
    casting_type: "Invitation",
    participants: [],
    id: null,
    repetition: false,
    repetition_number: 1,
    repetition_frequency: "Daily",
    repetition_end_date: null,
    selected_days: [],
    teams: [],
    steps: [],
    moment_privacy: "participant only",
    moment_privacy_teams: [],
    moment_password: null,
    location: null,
    agenda: null,
    address: null,
    room_details: null,
    phone: null,
    share_by: null,
    price: null,
    max_participants_register: 0,
    casting_tab: null,
    solution_id: null,
    solution_tab: "use a template",
    client: null,
    client_id: null,
    destination: null,
    destination_id: null,
    destination_type: null,
  });

  const getCompletedMeetings = async (startDate, forceSync = false) => {
    let response;
    setBtnDisable(true);
    setLoading(true);
    setFormState(getEmptyFormState());
    setMeeting(null);
    const currentTime = new Date();
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const options = { timeZone: userTimeZone };
    const timeInUserZone = new Date(
      currentTime.toLocaleString("en-US", options)
    );

    const formattedTime = formatTime(timeInUserZone);
    const formattedDate = formatDate(timeInUserZone);

    try {
      const start = new Date(startDate);
      const end = new Date(start);

      // Adjust date range based on current view
      if (currentView === Views.WEEK) {
        end.setDate(start.getDate() + 6);
      } else if (currentView === Views.MONTH) {
        end.setMonth(start.getMonth() + 1);
      }

      const startDateStr = formatDateForApi(start);
      const endDateStr = formatDateForApi(end);

      if (isFirstLoad) {
        const interval = setInterval(() => {
          setClosedProgress((prev) => {
            if (prev >= 90) {
              clearInterval(interval);
              return 90;
            }
            return prev + 10;
          });
        }, 200);
      }
      // Use forceSync parameter instead of syncAgenda state
      const shouldSync = forceSync || syncAgenda;

      if (selectedAgenda?.tektime && selectedAgenda?.google) {
        response = await axios.get(
          `${API_BASE_URL}/get-all-meetings/tektime-google-agenda?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}&m_start_date_filter=${startDateStr}&m_end_date_filter=${endDateStr}&sync_agenda=${shouldSync}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
      } else if (selectedAgenda?.tektime) {
        response = await axios.get(
          `${API_BASE_URL}/get-all-meetings/tektime-agenda?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}&m_start_date_filter=${startDateStr}&m_end_date_filter=${endDateStr}&sync_agenda=${shouldSync}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
      } else if (selectedAgenda?.google) {
        response = await axios.get(
          `${API_BASE_URL}/get-all-meetings/google-agenda?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}&m_start_date_filter=${startDateStr}&m_end_date_filter=${endDateStr}&sync_agenda=${shouldSync}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
      }

      if (response?.status === 200) {
        const meetings = response?.data?.meetings || response?.data?.data || [];
        const transformedMeetings = meetings.map((meeting) => {
          const transformedMeeting = transformMeetingToEvent(meeting);
          return transformedMeeting;
        });
        const filteredMeetings = transformedMeetings.filter(
          (meeting) => meeting !== null
        );

        const sortedMeetings = filteredMeetings.sort(
          (a, b) => new Date(a.start) - new Date(b.start)
        );

        if (sortedMeetings.length > 0 && currentView === Views.WEEK) {
          const earliestMeeting = sortedMeetings[0];
          const latestMeeting = sortedMeetings[sortedMeetings.length - 1];

          const minTime = new Date(earliestMeeting.start);
          const maxTime = new Date(latestMeeting.end);
          setMin(minTime);
          setMax(maxTime);
        }

        if (filteredMeetings.length > 0 && currentView === Views.WEEK) {
          let earliestHr = 24;
          let latestHr = 0;

          const weekStart = new Date(startDate);
          const weekEnd = new Date(weekStart);
          weekEnd.setDate(weekStart.getDate() + 7);

          filteredMeetings.forEach((meeting) => {
            const start = new Date(meeting.start);
            const end = new Date(meeting.end);

            if (
              start >= weekStart &&
              end <= weekEnd &&
              start.toDateString() === end.toDateString()
            ) {
              const startHour = start.getHours();
              const endHour = end.getHours();

              earliestHr = Math.min(earliestHr, startHour);
              latestHr = Math.max(latestHr, endHour);
            }
          });

          if (earliestHr !== 24) setEarliestHour(earliestHr);
          if (latestHr !== 0) setLatestHour(latestHr);
        }

        setOverlappingSlots(getOverlappingSlots(filteredMeetings, 15));
        setAgendaCount(filteredMeetings.length);
        setMyEventsList(filteredMeetings);

        setClosedProgress(100);
        setFirstTime(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
      setBtnDisable(false);
      setSyncAgenda(false);
    }
  };

  // Add this function to handle the refresh sync
  const handleRefreshSync = async () => {
    setSyncAgenda(true);
    setLoading(true);
    setBtnDisable(true);

    try {
      // Force a fresh API call with sync_agenda=true
      await getCompletedMeetings(currentStartDate, true);
    } finally {
      setLoading(false);
      setBtnDisable(false);
    }
  };

  const minTime = useMemo(() => {
    if (currentView === Views.MONTH) return new Date(0, 0, 0, 0, 0, 0);
    const date = new Date();
    const hour =
      Number.isInteger(earliestHour) && earliestHour >= 0 && earliestHour <= 23
        ? earliestHour
        : 9;
    date.setHours(hour, 0, 0);
    return date;
  }, [earliestHour, currentStartDate, currentView]);

  const maxTime = useMemo(() => {
    if (currentView === Views.MONTH) return new Date(0, 0, 0, 23, 59, 59);
    const date = new Date();
    const hour =
      Number.isInteger(latestHour) && latestHour >= 0 && latestHour <= 23
        ? latestHour
        : 17;
    date.setHours(hour, 59, 59);
    return date;
  }, [latestHour, currentStartDate, currentView]);

  useEffect(() => {
    if (selectedAgenda) {
      getCompletedMeetings(currentStartDate, false);
    }
  }, [currentStartDate, selectedAgenda, currentView]);

  const getFormattedAbortDateTime = (abortDateTime, timezone) => {
    const userTimezone = moment.tz.guess();
    return moment
      .tz(abortDateTime, "YYYY-MM-DD HH:mm:ss", timezone || "UTC")
      .tz(userTimezone)
      .toDate();
  };

  const transformMeetingToEvent = (meeting) => {
    if (
      ![
        "active",
        "closed",
        "abort",
        "in_progress",
        "to_finish",
        "todo",
      ].includes(meeting.status)
    ) {
      console.log("Filtered out meeting due to status:", meeting);
      return null;
    }

    let start, end;

    const userTimezone = moment.tz.guess();
    const meetingTimezone = meeting?.timezone || "UTC";
    if (meeting.status === "abort") {
      start = moment
        .tz(
          `${meeting?.date} ${meeting?.starts_at}`,
          "YYYY-MM-DD HH:mm:ss",
          meetingTimezone
        )
        .tz(userTimezone)
        .toDate();
      end = getFormattedAbortDateTime(
        meeting?.abort_end_time,
        meeting?.timezone
      );
    } else if (
      meeting.status === "closed" ||
      meeting.status === "in_progress" ||
      meeting?.status === "to_finish" ||
      meeting?.status === "todo"
    ) {
      start = moment
        .tz(
          `${meeting?.date} ${meeting?.starts_at}`,
          "YYYY-MM-DD HH:mm:ss",
          meetingTimezone
        )
        .tz(userTimezone)
        .toDate();

      const estimateDate =
        meeting.estimate_time?.split("T")[0] ||
        meeting.estimate_time?.split(" ")[0];
      const estimateTime =
        meeting.estimate_time?.split("T")[1] ||
        meeting.estimate_time?.split(" ")[1] ||
        "00:00:00";
      end = moment
        .tz(
          `${estimateDate} ${estimateTime}`,
          "YYYY-MM-DD HH:mm:ss",
          meetingTimezone
        )
        .tz(userTimezone)
        .toDate();
    } else {
      start = moment
        .tz(
          `${meeting?.date} ${meeting?.start_time}`,
          "YYYY-MM-DD HH:mm:ss",
          meetingTimezone
        )
        .tz(userTimezone)
        .toDate();
      const estimateDate =
        meeting.estimate_time?.split("T")[0] ||
        meeting.estimate_time?.split(" ")[0];
      const estimateTime =
        meeting.estimate_time?.split("T")[1] ||
        meeting.estimate_time?.split(" ")[1] ||
        "00:00:00";
      end = moment
        .tz(
          `${estimateDate} ${estimateTime}`,
          "YYYY-MM-DD HH:mm:ss",
          meetingTimezone
        )
        .tz(userTimezone)
        .toDate();
    }

    return {
      id: meeting.id,
      title: meeting.title,
      start: start,
      end: end,
      allDay: false,
      resource: meeting,
      steps: meeting?.steps,
    };
  };

  const eventPropGetter = (event) => {
    const status = event?.resource?.status;
    const timezone = event?.resource?.timezone || "Europe/Paris";
    const now = moment().utcOffset(timezone);
    const isPast = moment(event.end).isBefore(now) && status !== "in_progress";

    let borderColor = "#ccc";
    let borderWidth = "2px";
    let backgroundColor = "#fff";
    let zIndex = 1;

    const isSelected = selectedEvent && selectedEvent?.id === event.id;

    if (isSelected) {
      backgroundColor = "#f0f7ff";
      borderColor = "#0066cc";
      borderWidth = "3px";
    } else if (status === "active") {
      const meetingDateTime = moment(
        `${event?.resource?.date}T${event?.resource?.start_time}`
      ).utcOffset(timezone);
      const isFutureMeeting = meetingDateTime?.isAfter(now);

      borderColor = isFutureMeeting ? "rgb(91, 170, 234)" : "red";
      borderWidth = "5px";
    } else if (status === "in_progress") {
      borderColor = "yellow";
      borderWidth = "5px";
    } else if (status === "to_finish") {
      borderColor = "#ff9800";
      borderWidth = "5px";
    } else if (status === "todo") {
      borderColor = "#6c757d";
      borderWidth = "5px";
    } else if (status === "closed") {
      borderColor = "rgb(119, 214, 113)";
      borderWidth = "5px";
    } else if (status === "abort") {
      borderColor = "rgb(119, 19, 241)";
      borderWidth = "5px";
    }

    return {
      style: {
        borderLeft: `${borderWidth} solid ${borderColor}`,
        backgroundColor: backgroundColor,
        paddingLeft: "8px",
        borderRadius: "4px",
        color: "#000000",
        opacity: 1,
        boxShadow: isSelected ? "0 0 5px rgba(0, 102, 204, 0.5)" : "none",
        zIndex: zIndex,
      },
    };
  };

  const getOverlappingSlots = (events, step = 15) => {
    const overlaps = new Set();

    for (let i = 0; i < events.length; i++) {
      for (let j = i + 1; j < events.length; j++) {
        const e1 = events[i];
        const e2 = events[j];

        const start1 = moment(e1.start);
        const end1 = moment(e1.end);
        const start2 = moment(e2.start);
        const end2 = moment(e2.end);

        if (start1.isBefore(end2) && start2.isBefore(end1)) {
          const overlapStart = moment.max(start1, start2).startOf("minute");
          const overlapEnd = moment.min(end1, end2).startOf("minute");

          let current = overlapStart.clone();
          while (current < overlapEnd) {
            overlaps.add(current.format("HH:mm"));
            current.add(step, "minutes");
          }
        }
      }
    }

    return overlaps;
  };

  const CustomGutter = ({ date }) => {
    const timeLabel = moment(date).format("HH:mm");
    const isVisible = overlappingSlots.has(timeLabel);
    return (
      <div
        style={{
          height: "100%",
          visibility: isVisible ? "visible" : "hidden",
          display: isVisible ? "block" : "none",
        }}
      >
        {timeLabel}
      </div>
    );
  };

  const toggleAgenda = (type) => {
    setOffset(0);
    setAgendaEventOffset(0);
    setSelectedAgenda((prev) => {
      const newState = { ...prev };

      if (type === "tektime") {
        if (prev.tektime && !prev.google && !prev.outlook) return prev;
        newState.tektime = !prev.tektime;
      } else if (type === "google") {
        if (prev.google && !prev.tektime && !prev.outlook) return prev;
        newState.google = !prev.google;
      } else if (type === "outlook") {
        if (prev.outlook && !prev.tektime && !prev.google) return prev;
        newState.outlook = !prev.outlook;
      }

      return newState;
    });
  };

  const loginGoogleAndSaveProfileData = async () => {
    await googleLoginAndSaveProfileScheduled();
  };

  const handleSelectEvent = (event) => {
    setSelectedEvent(event);
    if (
      event?.resource?.status === "active" ||
      event?.resource?.status === "in_progress" ||
      event?.resource?.status === "to_finish" ||
      event?.resource?.status === "todo"
    ) {
      navigate(`/invite/${event?.resource?.id}`, {
        state: { from: "meeting" },
      });
    } else {
      navigate(`/present/invite/${event?.resource?.id}`, {
        state: { from: "meeting" },
      });
    }
  };

  const handleCalendarClick = () => {
    setSelectedEvent(null);
  };

  const handleViewChange = (view) => {
    setCurrentView(view);
  };

  const statuses = [
    { name: t("calendar.status1"), color: "rgb(119 214 113)" },
    { name: t("calendar.status2"), color: "yellow" },
    { name: t("calendar.status3"), color: "red" },
    { name: t("calendar.status4"), color: "rgb(119 19 241)" },
    { name: t("calendar.status5"), color: "rgb(91 170 234)" },
  ];
  const userID = sessionStorage.getItem("user_id");

  const getUser = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/users/${userID}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      if (response.status === 200) {
        setUser(response?.data?.data);
      }
    } catch (error) {
      // console.log(error?.message);
    }
  };
  useEffect(() => {
    getUser();
  }, [callUser]);

  
  const loginOutlookAndSaveProfileData = async () => {
    await outlookLoginAndSaveProfile();
  };

  return (
    <div className={`myCustomHeight ${loading ? "screen-blur" : ""}`}>
      {loading && (
        <div className="progress-overlay" style={{ background: "transparent" }}>
          <div style={{ width: "50%" }}>
            <ProgressBar now={closedProgress} animated />
          </div>
        </div>
      )}
      <div className="mb-3 d-flex align-items-center">
        {/* Tektime Agenda Toggle */}
        <label className="d-flex align-items-center">
          <ReactToggle
            icons={false}
            className="toggle-playback"
            checked={selectedAgenda.tektime}
            onChange={() => toggleAgenda("tektime")}
          />
          <span className="ms-2">Tektime Agenda</span>
        </label>
        {/* Google Agenda Toggle */}
        <label className="d-flex align-items-center ms-3">
          {user?.email_links?.some((item) => item?.platform === "Gmail") ? (
            <>
              <ReactToggle
                icons={false}
                className="toggle-playback"
                checked={selectedAgenda.google}
                onChange={() => {
                  toggleAgenda("google");
                  const hasGoogleAgenda = user?.email_links?.some(
                    (item) => item?.platform === "Gmail"
                  );
                  if (!hasGoogleAgenda) {
                    loginGoogleAndSaveProfileData();
                  }
                }}
              />
              <span className="ms-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-label="Google Calendar"
                  role="img"
                  viewBox="0 0 512 512"
                  width="33px"
                  height="34px"
                  fill="#000000"
                >
                  <rect width="512" height="512" rx="15%" fill="#ffffff"></rect>
                  <path
                    d="M100 340h74V174H340v-74H137Q100 100 100 135"
                    fill="#4285f4"
                  ></path>
                  <path d="M338 100v76h74v-41q0-35-35-35" fill="#1967d2"></path>
                  <path d="M338 174h74V338h-74" fill="#fbbc04"></path>
                  <path d="M100 338v39q0 35 35 35h41v-74" fill="#188038"></path>
                  <path d="M174 338H338v74H174" fill="#34a853"></path>
                  <path d="M338 412v-74h74" fill="#ea4335"></path>
                  <path
                    d="M204 229a25 22 1 1 1 25 27h-9h9a25 22 1 1 1-25 27M270 231l27-19h4v-7V308"
                    stroke="#4285f4"
                    strokeWidth="15"
                    strokeLinejoin="bevel"
                    fill="none"
                  ></path>
                </svg>
                {user.email_links
                  .filter((item) => item?.platform === "Gmail")
                  .map((item, index) => (
                    <span key={index} className="ms-2">
                      {item?.value}
                    </span>
                  ))}
              </span>
            </>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => {
                // Replace this with your modal opening function
                loginGoogleAndSaveProfileData();
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-label="Google Calendar"
                role="img"
                viewBox="0 0 512 512"
                width="33px"
                height="34px"
                fill="#000000"
                className="me-2"
              >
                <rect width="512" height="512" rx="15%" fill="#ffffff"></rect>
                <path
                  d="M100 340h74V174H340v-74H137Q100 100 100 135"
                  fill="#4285f4"
                ></path>
                <path d="M338 100v76h74v-41q0-35-35-35" fill="#1967d2"></path>
                <path d="M338 174h74V338h-74" fill="#fbbc04"></path>
                <path d="M100 338v39q0 35 35 35h41v-74" fill="#188038"></path>
                <path d="M174 338H338v74H174" fill="#34a853"></path>
                <path d="M338 412v-74h74" fill="#ea4335"></path>
                <path
                  d="M204 229a25 22 1 1 1 25 27h-9h9a25 22 1 1 1-25 27M270 231l27-19h4v-7V308"
                  stroke="#4285f4"
                  strokeWidth="15"
                  strokeLinejoin="bevel"
                  fill="none"
                ></path>
              </svg>
              Ajouter un agenda
            </button>
          )}
        </label>

        {user?.email_links?.some((item) => item?.platform === "Gmail") && (
          <button
            className="btn btn-primary ms-3"
            onClick={handleRefreshSync}
            disabled={loading || btnDisable}
          >
            {loading ? "Syncing..." : t("refresh")}
          </button>
        )}

        {/* Outlook Agenda Toggle */}
        <label className="d-flex align-items-center ms-3">
          {user?.email_links?.some((item) => item?.platform === "Outlook") ? (
            <>
              <ReactToggle
                icons={false}
                className="toggle-playback"
                checked={selectedAgenda.outlook}
                onChange={() => {
                  toggleAgenda("outlook");
                  const hasGoogleAgenda = user?.email_links?.some(
                    (item) => item?.platform === "Outlook"
                  );
                  if (!hasGoogleAgenda) {
                    loginOutlookAndSaveProfileData();
                  }
                }}
              />
              <span className="ms-2">
                {/* <svg
                  width="33px"
                  height="34px"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    {" "}
                    <rect
                      x="10"
                      y="2"
                      width="20"
                      height="28"
                      rx="2"
                      fill="#1066B5"
                    ></rect>{" "}
                    <rect
                      x="10"
                      y="2"
                      width="20"
                      height="28"
                      rx="2"
                      fill="url(#paint0_linear_87_7742)"
                    ></rect>{" "}
                    <rect
                      x="10"
                      y="5"
                      width="10"
                      height="10"
                      fill="#32A9E7"
                    ></rect>{" "}
                    <rect
                      x="10"
                      y="15"
                      width="10"
                      height="10"
                      fill="#167EB4"
                    ></rect>{" "}
                    <rect
                      x="20"
                      y="15"
                      width="10"
                      height="10"
                      fill="#32A9E7"
                    ></rect>{" "}
                    <rect
                      x="20"
                      y="5"
                      width="10"
                      height="10"
                      fill="#58D9FD"
                    ></rect>{" "}
                    <mask
                      id="mask0_87_7742"
                      style="mask-type:alpha"
                      maskUnits="userSpaceOnUse"
                      x="8"
                      y="14"
                      width="24"
                      height="16"
                    >
                      {" "}
                      <path
                        d="M8 14H30C31.1046 14 32 14.8954 32 16V28C32 29.1046 31.1046 30 30 30H10C8.89543 30 8 29.1046 8 28V14Z"
                        fill="url(#paint1_linear_87_7742)"
                      ></path>{" "}
                    </mask>{" "}
                    <g mask="url(#mask0_87_7742)">
                      {" "}
                      <path d="M32 14V18H30V14H32Z" fill="#135298"></path>{" "}
                      <path
                        d="M32 30V16L7 30H32Z"
                        fill="url(#paint2_linear_87_7742)"
                      ></path>{" "}
                      <path
                        d="M8 30V16L33 30H8Z"
                        fill="url(#paint3_linear_87_7742)"
                      ></path>{" "}
                    </g>{" "}
                    <path
                      d="M8 12C8 10.3431 9.34315 9 11 9H17C18.6569 9 20 10.3431 20 12V24C20 25.6569 18.6569 27 17 27H8V12Z"
                      fill="#000000"
                      fill-opacity="0.3"
                    ></path>{" "}
                    <rect
                      y="7"
                      width="18"
                      height="18"
                      rx="2"
                      fill="url(#paint4_linear_87_7742)"
                    ></rect>{" "}
                    <path
                      d="M14 16.0693V15.903C14 13.0222 11.9272 11 9.01582 11C6.08861 11 4 13.036 4 15.9307V16.097C4 18.9778 6.07278 21 9 21C11.9114 21 14 18.964 14 16.0693ZM11.6424 16.097C11.6424 18.0083 10.5665 19.1579 9.01582 19.1579C7.46519 19.1579 6.37342 17.9806 6.37342 16.0693V15.903C6.37342 13.9917 7.44937 12.8421 9 12.8421C10.5348 12.8421 11.6424 14.0194 11.6424 15.9307V16.097Z"
                      fill="white"
                    ></path>{" "}
                    <defs>
                      {" "}
                      <linearGradient
                        id="paint0_linear_87_7742"
                        x1="10"
                        y1="16"
                        x2="30"
                        y2="16"
                        gradientUnits="userSpaceOnUse"
                      >
                        {" "}
                        <stop stop-color="#064484"></stop>{" "}
                        <stop offset="1" stop-color="#0F65B5"></stop>{" "}
                      </linearGradient>{" "}
                      <linearGradient
                        id="paint1_linear_87_7742"
                        x1="8"
                        y1="26.7692"
                        x2="32"
                        y2="26.7692"
                        gradientUnits="userSpaceOnUse"
                      >
                        {" "}
                        <stop stop-color="#1B366F"></stop>{" "}
                        <stop offset="1" stop-color="#2657B0"></stop>{" "}
                      </linearGradient>{" "}
                      <linearGradient
                        id="paint2_linear_87_7742"
                        x1="32"
                        y1="23"
                        x2="8"
                        y2="23"
                        gradientUnits="userSpaceOnUse"
                      >
                        {" "}
                        <stop stop-color="#44DCFD"></stop>{" "}
                        <stop offset="0.453125" stop-color="#259ED0"></stop>{" "}
                      </linearGradient>{" "}
                      <linearGradient
                        id="paint3_linear_87_7742"
                        x1="8"
                        y1="23"
                        x2="32"
                        y2="23"
                        gradientUnits="userSpaceOnUse"
                      >
                        {" "}
                        <stop stop-color="#259ED0"></stop>{" "}
                        <stop offset="1" stop-color="#44DCFD"></stop>{" "}
                      </linearGradient>{" "}
                      <linearGradient
                        id="paint4_linear_87_7742"
                        x1="0"
                        y1="16"
                        x2="18"
                        y2="16"
                        gradientUnits="userSpaceOnUse"
                      >
                        {" "}
                        <stop stop-color="#064484"></stop>{" "}
                        <stop offset="1" stop-color="#0F65B5"></stop>{" "}
                      </linearGradient>{" "}
                    </defs>{" "}
                  </g>
                </svg> */}
                {user.email_links
                  .filter((item) => item?.platform === "Outlook")
                  .map((item, index) => (
                    <span key={index} className="ms-2">
                      {item?.value}
                    </span>
                  ))}
              </span>
            </>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => {
                // Replace this with your modal opening function
                loginOutlookAndSaveProfileData();
              }}
            >
              {/* <svg
                width="33px"
                height="34px"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  {" "}
                  <rect
                    x="10"
                    y="2"
                    width="20"
                    height="28"
                    rx="2"
                    fill="#1066B5"
                  ></rect>{" "}
                  <rect
                    x="10"
                    y="2"
                    width="20"
                    height="28"
                    rx="2"
                    fill="url(#paint0_linear_87_7742)"
                  ></rect>{" "}
                  <rect
                    x="10"
                    y="5"
                    width="10"
                    height="10"
                    fill="#32A9E7"
                  ></rect>{" "}
                  <rect
                    x="10"
                    y="15"
                    width="10"
                    height="10"
                    fill="#167EB4"
                  ></rect>{" "}
                  <rect
                    x="20"
                    y="15"
                    width="10"
                    height="10"
                    fill="#32A9E7"
                  ></rect>{" "}
                  <rect
                    x="20"
                    y="5"
                    width="10"
                    height="10"
                    fill="#58D9FD"
                  ></rect>{" "}
                  <mask
                    id="mask0_87_7742"
                    style="mask-type:alpha"
                    maskUnits="userSpaceOnUse"
                    x="8"
                    y="14"
                    width="24"
                    height="16"
                  >
                    {" "}
                    <path
                      d="M8 14H30C31.1046 14 32 14.8954 32 16V28C32 29.1046 31.1046 30 30 30H10C8.89543 30 8 29.1046 8 28V14Z"
                      fill="url(#paint1_linear_87_7742)"
                    ></path>{" "}
                  </mask>{" "}
                  <g mask="url(#mask0_87_7742)">
                    {" "}
                    <path d="M32 14V18H30V14H32Z" fill="#135298"></path>{" "}
                    <path
                      d="M32 30V16L7 30H32Z"
                      fill="url(#paint2_linear_87_7742)"
                    ></path>{" "}
                    <path
                      d="M8 30V16L33 30H8Z"
                      fill="url(#paint3_linear_87_7742)"
                    ></path>{" "}
                  </g>{" "}
                  <path
                    d="M8 12C8 10.3431 9.34315 9 11 9H17C18.6569 9 20 10.3431 20 12V24C20 25.6569 18.6569 27 17 27H8V12Z"
                    fill="#000000"
                    fill-opacity="0.3"
                  ></path>{" "}
                  <rect
                    y="7"
                    width="18"
                    height="18"
                    rx="2"
                    fill="url(#paint4_linear_87_7742)"
                  ></rect>{" "}
                  <path
                    d="M14 16.0693V15.903C14 13.0222 11.9272 11 9.01582 11C6.08861 11 4 13.036 4 15.9307V16.097C4 18.9778 6.07278 21 9 21C11.9114 21 14 18.964 14 16.0693ZM11.6424 16.097C11.6424 18.0083 10.5665 19.1579 9.01582 19.1579C7.46519 19.1579 6.37342 17.9806 6.37342 16.0693V15.903C6.37342 13.9917 7.44937 12.8421 9 12.8421C10.5348 12.8421 11.6424 14.0194 11.6424 15.9307V16.097Z"
                    fill="white"
                  ></path>{" "}
                  <defs>
                    {" "}
                    <linearGradient
                      id="paint0_linear_87_7742"
                      x1="10"
                      y1="16"
                      x2="30"
                      y2="16"
                      gradientUnits="userSpaceOnUse"
                    >
                      {" "}
                      <stop stop-color="#064484"></stop>{" "}
                      <stop offset="1" stop-color="#0F65B5"></stop>{" "}
                    </linearGradient>{" "}
                    <linearGradient
                      id="paint1_linear_87_7742"
                      x1="8"
                      y1="26.7692"
                      x2="32"
                      y2="26.7692"
                      gradientUnits="userSpaceOnUse"
                    >
                      {" "}
                      <stop stop-color="#1B366F"></stop>{" "}
                      <stop offset="1" stop-color="#2657B0"></stop>{" "}
                    </linearGradient>{" "}
                    <linearGradient
                      id="paint2_linear_87_7742"
                      x1="32"
                      y1="23"
                      x2="8"
                      y2="23"
                      gradientUnits="userSpaceOnUse"
                    >
                      {" "}
                      <stop stop-color="#44DCFD"></stop>{" "}
                      <stop offset="0.453125" stop-color="#259ED0"></stop>{" "}
                    </linearGradient>{" "}
                    <linearGradient
                      id="paint3_linear_87_7742"
                      x1="8"
                      y1="23"
                      x2="32"
                      y2="23"
                      gradientUnits="userSpaceOnUse"
                    >
                      {" "}
                      <stop stop-color="#259ED0"></stop>{" "}
                      <stop offset="1" stop-color="#44DCFD"></stop>{" "}
                    </linearGradient>{" "}
                    <linearGradient
                      id="paint4_linear_87_7742"
                      x1="0"
                      y1="16"
                      x2="18"
                      y2="16"
                      gradientUnits="userSpaceOnUse"
                    >
                      {" "}
                      <stop stop-color="#064484"></stop>{" "}
                      <stop offset="1" stop-color="#0F65B5"></stop>{" "}
                    </linearGradient>{" "}
                  </defs>{" "}
                </g>
              </svg> */}
              Ajouter un agenda
            </button>
          )}
        </label>

        {user?.email_links?.some((item) => item?.platform === "Outlook") && (
          <button
            className="btn btn-primary ms-3"
            onClick={handleRefreshSync}
            disabled={loading || btnDisable}
          >
            {loading ? "Syncing..." : t("refresh")}
          </button>
        )}
      </div>
      <Calendar
        localizer={localizer}
        events={filteredEvents}
        onSelectEvent={handleSelectEvent}
        startAccessor="start"
        endAccessor="end"
        views={[Views.WEEK, Views.MONTH]} // Added MONTH view
        defaultView={Views.WEEK}
        view={currentView} // Controlled view
        onView={handleViewChange} // Handle view changes
        showAllDayEvents={false}
        allDayAccessor={null}
        toolbar={true}
        tooltipAccessor={() => null}
        popup={true}
        allDaySlot={true}
        components={{
          week: {
            header: CustomDateHeader,
            event: CustomEvent,
            timeGutterHeader: CustomGutter,
          },
          month: {
            event: MonthEvent,
            dateHeader: MonthDateHeader,
          },
          toolbar: (props) => (
            <CustomToolbar
              {...props}
              view={currentView}
              onView={handleViewChange}
            />
          ),
          eventWrapper: EventWrapper,
        }}
        eventPropGetter={eventPropGetter}
        formats={{
          timeGutterFormat: "HH:mm",
          dayRangeHeaderFormat: "MMMM D, YYYY",
          eventTimeRangeFormat: () => "",
        }}
        date={currentStartDate}
        onNavigate={(date) => setCurrentStartDate(date)}
        dayLayoutAlgorithm="no-overlap"
        min={minTime}
        max={maxTime}
      />

      <div className="status-legend">
        <div className="status-list">
          {statuses.map((status, index) => (
            <div key={index} className="status-item">
              <span
                className="status-dot"
                style={{ backgroundColor: status.color }}
              ></span>
              {status.name}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReactBigCalendar;
